<template>
  <div class="flex flex-col flex-grow bg-gray-50">
    <div class="container flex flex-col gap-1 flex-grow pb-5 md:pb-10">
      <slot />
    </div>
  </div>
</template>
